import { getSplittedText } from "../../../../utils/functions";

export const DISABILITY_CATEGORY_DOCUMENT_SEPARATOR = '|';
export const DISABILITY_CATEGORY_DOCUMENT_TEMPLATE_SEPARATOR = '::';

export   const getDocumentLabelsAndTemplateUrls= (description: string): {label: string, templateUrl: string}[] => {
    if (!description) return [];

    return getSplittedText(description, DISABILITY_CATEGORY_DOCUMENT_SEPARATOR).map(item => {
      const [label, templateUrl] = getSplittedText(item, DISABILITY_CATEGORY_DOCUMENT_TEMPLATE_SEPARATOR);
      return {
        label: label?.trim(),
        templateUrl: templateUrl?.trim()
      };
    });
  };